import { Component } from '@angular/core';

@Component({
  selector: 'ngx-layout-popover',
  templateUrl: './layout-popover.component.html',
  styleUrl: './layout-popover.component.scss'
})
export class LayoutPopoverComponent {
  title:string = "Title";
  gridCellLayoutClassList = [
    "cell-layout-default",
    "cell-layout-classic-card",
    "cell-layout-split-top-bottom",
    "cell-layout-all-top-halfed",
    "cell-layout-all-bottom-halfed",
    "cell-layout-fit-both"
  ]

  bannerCellLayoutClassList = [
    "wide-img-bg-wrapper",
    "wide-vert-noimg-wrapper",
    "wide-vert-img-wrapper",
    "wide-hori-wave-wrapper",
    "wide-hori-sqr-wrapper"
  ]

  testimonialLayoutClassList = [
    "default",
    "reverse"
  ]
}
